import Swal from 'sweetalert2';
import CryptoJS from 'react-native-crypto-js';

const CLAVES_SESION = ['caav_token', '_cv_data_', '_cv_'];

let cerrando = false;

const expiracionToken = token => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return payload.exp ? payload.exp * 1000 : null;
    } catch {
        return null;
    }
};

export const tokenVigente = () => {
    const token = localStorage.getItem('caav_token');
    if (!token) return false;
    const exp = expiracionToken(token);
    return exp !== null && exp > Date.now();
};

export const limpiarSesion = () => CLAVES_SESION.forEach(clave => localStorage.removeItem(clave));

// Datos del usuario que guarda el login (nombre, tipo, id, puesto), cifrados en localStorage
export const leerDatosSesion = () => {
    try {
        const bytes = CryptoJS.AES.decrypt(localStorage.getItem('_cv_data_'), process.env.REACT_APP_AES_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch {
        return null;
    }
};

export const actualizarDatosSesion = cambios => {
    const datos = { ...leerDatosSesion(), ...cambios };
    localStorage.setItem('_cv_data_', CryptoJS.AES.encrypt(JSON.stringify(datos), process.env.REACT_APP_AES_KEY).toString());
    return datos;
};

export const cerrarSesionExpirada = async () => {
    if (cerrando) return;
    cerrando = true;
    limpiarSesion();
    await Swal.fire('Sesión expirada', 'Tu sesión expiró, vuelve a iniciar sesión', 'warning');
    window.location.replace('/');
};

const usaToken = init => {
    const headers = init?.headers;
    if (!headers) return false;
    if (headers instanceof Headers) return headers.has('Authorization');
    return Boolean(headers.Authorization ?? headers.authorization);
};

export const instalarControlSesion = () => {
    const fetchOriginal = window.fetch.bind(window);
    // Los helpers llaman fetch directo; interceptarlo evita tocar cada uno
    window.fetch = async (input, init) => {
        const response = await fetchOriginal(input, init);
        if (response.status === 401 && usaToken(init) && localStorage.getItem('caav_token')) {
            cerrarSesionExpirada();
        }
        return response;
    };

    const token = localStorage.getItem('caav_token');
    const exp = token && expiracionToken(token);
    if (!exp) return;
    // En el login un token viejo no estorba: se reemplaza al iniciar sesión
    if (exp <= Date.now() && window.location.pathname === '/') return limpiarSesion();
    setTimeout(cerrarSesionExpirada, Math.max(exp - Date.now(), 0));
};
